import { forwardRef } from 'react';
import { Field, ErrorMessage, FieldProps } from 'formik';
import { Checkbox as AntCheckbox, Flex } from 'antd';
import type { CheckboxRef } from 'antd';
import clsx from 'clsx';
import TextError from 'components/TextError';
import If from 'components/If';
import { CheckboxProps } from 'utils/globalTypes';
import styles from './index.module.scss';

type CheckboxFieldProps = Omit<CheckboxProps, 'name'>;

export const Checkbox = forwardRef<CheckboxRef, CheckboxFieldProps>(
  (props, ref) => {
    const { className, qaSelector, ...rest } = props;
    const checkboxClassName = clsx(styles.checkbox, className);

    return (
      <AntCheckbox
        className={checkboxClassName}
        data-qa-selector={qaSelector}
        ref={ref}
        {...rest}
      />
    );
  },
);

function FormikCheckbox(props: CheckboxProps) {
  const { name, showErrMsg = true, ...rest } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <Field name={name} type='checkbox'>
        {({ field }: FieldProps) => {
          return <Checkbox id={name} {...field} {...rest} />;
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => (
            <TextError msg={msg} qaSelector={`${props?.qaSelector}-error`} />
          )}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default FormikCheckbox;
